import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // ✅ import
import SideMenu from "../components/SideMenu";
import UserMenu from "../components/UserMenu";
import Header from "../components/Header";
import Footer from "../components/Footer";
import RegularizeTableItCell from "../components/RegularizeTableItCell";

const PowerRegularizationItCell = () => {
  const [isSideOpen, setSideOpen] = useState(false);
  const [isUserOpen, setUserOpen] = useState(false);
  const navigate = useNavigate(); // ✅ initialize navigation

  const handleRedirect = () => {
    navigate("/SroTimeManager"); // ✅ replace with your route path
  };

  return (
    <div className="flex h-screen overflow-hidden">
      {/* MAIN CONTENT */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="shadow-sm flex justify-between items-center p-4">
          <Header />

          {/* ✅ Redirect Button */}
          <button
            onClick={handleRedirect}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
          >
            Time Update
          </button>
        </header>

        <main className="flex-1 overflow-auto p-2">
          <RegularizeTableItCell />
        </main>

        <footer className="bg-blue-100 text-center p-0">
          <Footer />
        </footer>
      </div>

      {/* RIGHT SIDEBAR */}
      <div
        className={`
          fixed inset-y-0 right-0 z-20 w-64 bg-white
          transform transition-transform duration-300 ease-in-out
          ${isUserOpen ? "translate-x-0" : "translate-x-full"}
          md:relative md:translate-x-0 md:block
        `}
      >
        <UserMenu className="h-full" />
      </div>

      {/* MOBILE NAV */}
      <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg md:hidden">
        <div className="flex justify-around p-2">
          <button onClick={() => setSideOpen((open) => !open)}>
            {/* MenuIcon */}
          </button>
          <button onClick={() => setUserOpen((open) => !open)}>
            {/* UserIcon */}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PowerRegularizationItCell;
